export default [{ code: 'homePage', name: '系统首页', icon: 'el-icon-s-home', parentKey: '', selfFlg: 'home', meta: { title: '系统首页' } }];
